import classNames from 'classnames';
import React from 'react';
import Background from 'images/firstview/background.png';
import PcImg from 'images/firstview/pc.png';
import Style from 'styles/components/first_view.module.scss';
import { graphql, useStaticQuery } from 'gatsby';

const FirstView = () => {
  const data = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          comachiApplicationUrl
        }
      }
    }
  `);

  return (
    <section className={Style.hero}>
      <img className={Style.hero__background} src={Background} alt="" />

      {/* PC: 左にタイトル+CTA、右に画像 / モバイル: タイトル→画像→CTA */}
      <div className={Style.hero__main}>
        <div className={Style.hero__text}>
          <p className={Style.hero__eyebrow}>EC Cart Service — comachicart</p>

          <h1 className={Style.hero__title}>
            作って終わりじゃない<br />
            育てるEC<br />
            <span className={Style.hero__accent}>comachicart</span>
          </h1>
        </div>

        <div className={Style.hero__visual}>
          <img className={Style.hero__img} src={PcImg} alt="ComachiCart ショップイメージ" />
        </div>

        <div className={Style.hero__cta}>
          <p className={Style.hero__sub}>
            初期費用 <strong>0円</strong>　月額費用 <strong>0円</strong>
          </p>

          <a href={data.site.siteMetadata.comachiApplicationUrl} className={Style.hero__btn}>
            無料で簡単ネットショップ開設
          </a>

          <p className={Style.hero__note}>
            <span>クレジット決済 3.2%〜</span>
            <span>最短3分で開設</span>
            <span>メールアドレスだけで登録可能</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default FirstView;
